export default {
  'pamm-supermarket': 'PAMM supermarket',
  type: 'Type',
  'pamm-detail': 'PAMM detail',

  'max-drawdown': 'Max Drawdown',
  share: 'Share',
  'subscribe-now': 'Subscribe Now',
  'total-profit': 'Total Profit',
  equity: 'Equity',
  'trading-introduction': {
    title: 'Trading Introduction',
    description:
      "Copy trading refers to investors automatically or manually replicating the trading operations of other successful traders through a trading platform. This model allows novice investors to follow experienced traders, thereby reducing the learning curve and increasing the success rate of investments. Novice investors do not need to delve deeply into complex trading techniques and market analysis; they only need to choose a successful trader to copy. Following experienced traders can improve the success rate of trades and reduce mistakes caused by lack of experience. Investors can follow multiple traders to achieve portfolio diversification and risk dispersion. Trading platforms typically provide real-time synchronization to ensure that copy trading operations are consistent with the trader's operations.",
  },

  actions: 'Actions',
  'pamm-Name': 'PAMM Name',
  'publish-Date': 'Publish Date',
  'expiry-Date': 'Expiry Date',
  'initial-Capital': 'Initial Capital',
  'current-Capital': 'Current Capital',
  'net-Value': 'Net Value',
  'today-Profit-Loss': 'Today Profit/Loss',
  'total-Profit-Loss': 'Total Profit/Loss',
  'profit-Distribution-Ratio': 'Profit Distribution Ratio',
  'profit-Distribution-Cycle': 'Profit Distribution Cycle',
  'allocated-Amount': 'Allocated Amount',
  'my-Profit': 'My Profit',
  'review-Status': 'Review Status',
  'publish-pamm': 'Publish PAMM',
  'my-pamm': 'My PAMM',
  'server-type': 'Server Type',
  'account-type': 'Account Type',
  leverage: 'Leverage',
  'pamm-type': 'PAMM Type',
  'management-fee': 'Management Fee',
  'fund-size': 'Fund Size',
  'profit-distribution-cycle': 'Profit Distribution Cycle',
  visibility: 'Visibility',
  introduction: 'Introduction',
  submit: 'Submit',
  sealed: 'Sealed',
  open: 'Open',
  'visible-to-all': 'Visible to All',
  'visible-to-lower-tier': 'Visible to Lower Tier',
  'visible-to-shared-only': 'Visible to Shared Only',
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
  'on-maturity': 'On Maturity',
  'fixed-ratio': 'Fixed Ratio',
  'variable-ratio': 'Variable Ratio',
  'please-select-server-type': 'Please select server type',
  'please-select-account-type': 'Please select account type',
  'please-select-leverage': 'Please select leverage',
  'please-select-pamm-type': 'Please select PAMM type',
  'please-enter-pamm-name': 'Please enter PAMM name',
  'please-select-management-fee': 'Please select management fee',
  'please-select-fund-size': 'Please select fund size',
  'please-select-stop-loss': 'Please select stop loss',
  'please-select-profit-distribution-cycle': 'Please select profit distribution cycle',
  'please-select-profit-distribution-ratio': 'Please select profit distribution ratio',
  'please-select-visibility': 'Please select visibility',
  'please-enter-introduction': 'Please enter introduction',
  'please-enter-registration-number': 'Please enter registration number',
  'please-enter-message-group': 'Please enter message group',
  'please-select-currency': 'Please select currency',
  'please-select-profit-distribution-method': 'Please select profit distribution method',
  'share-modal': {
    'total-profit-loss': 'Total Profit/Loss',
    'historical-max-drawdown': 'Historical Max Drawdown',
    'net-value': 'Net Value',
    code: 'Code',
    'save-image': 'Save Image',
    'copy-link': 'Copy Link',
    'send-email': 'Send Email',
    facebook: 'Facebook',
    x: 'X',
  },
  'verify-account-info': 'Verify account information to ensure secure operations',
  'subscription-amount': {
    label: 'Subscription Amount',
    required: 'Please enter the subscription amount',
    min: 'The subscription amount must be greater than 0',
  },
  detail: {
    '7-day': '7Days',
    '14-day': '14Days',
    '30-day': '30Days',
    'remaining-amount': 'Remaining Amount（{currency}）',
    'initial-capital': 'Initial Capital （{currency}）',
    'net-value': 'Net Value （{currency}）',
    'stop-loss': 'Stop Loss （{currency}）',
    'expiry-date': 'Expiry Date',
    'max-drawdown': 'Max Drawdown',
    'total-profit': 'Total Profit（{currency}）',
    'profit-distribution-ratio': 'Profit Distribution Ratio',
    equity: 'equit（{currency}）',
  },
  'super-market': {
    'page-title': 'PAMM Supermarket',
    type: 'Type',
    'pamm-name': 'PAMM Name',
    'pamm-manager': 'PAMM Manager',
    'release-date': 'Release Date',
    'subscription-scope': 'Subscription Scope',
    'initial-capital': 'Initial Capital',
    'current-capital': 'Current Capital',
    'write-off-amount': 'Write-off Amount',
    'net-value': 'Net Value',
    'stop-loss': 'Stop Loss',
    'max-historical-return': 'Max Historical Return',
    'profit-distribution-ratio': 'Profit Distribution Ratio',
    'profit-distribution-period': 'Profit Distribution Period',
    'buy-method': 'Buy Method',
    'exit-method': 'Exit Method',
    actions: 'Actions',
    'actions-detail': 'view detail',
  },
  my: {
    'page-title': 'My PAMM',
    'my-invested-pamm': 'My Invested PAMM',
    'my-managed-pamm': 'My Managed PAMM',
    'revenue-sharing-records': 'Revenue Sharing Records',
    'pamm-name': 'Pamm name',
    'pamm-manager': 'Pamm manager',
    'publish-date': 'Publish date',
    'expiry-date': 'Expiry date',
    'initial-fund': 'Initial Fund',
    'current-fund': 'Current Fund',
    'current-net-value': 'Current Net Value',
    'total-subscription': 'Total Subscription Amount',
    'redeemed-fund': 'Redeemed Fund',
    'distributed-profit': 'Distributed Profit',
    'allocatable-profit': 'Allocatable Profit',
    'remaining-fund': 'Remaining Fund',
    'total-profit-loss': 'Total Profit/Loss',
    'audit-status': 'Audit Status',
    actions: 'Actions',
    'continue-buy': 'Follow-on-Subscription',
    'instant-sell': 'Instant-Redemption',
    'revenue-sharing': {
      name: 'PAMM name',
      'installment-time': 'Installment Time',
      'installment-user': 'Installment User',
      'user-type': 'User Type',
      'installment-type': 'Installment Type',
      'installment-amount': 'Installment Amount',
      'installment-period': 'Installment Period',
      'expected-return': 'Expected Return',
      'cumulative-profit': 'Cumulative Profit',
      'account-highest-profit': 'Account Highest Profit',
    },
  },
  pl: {
    'page-title': 'Customer Profit/Loss',
    'pamv-main-account': 'PAMV Main Account',
    'customer-name': 'Customer Name',
    'customer-account': 'Customer Account',
    'total-purchase-funds': 'Total Purchase Funds',
    'discounted-funds': 'Discounted Funds',
    'remaining-funds': 'Remaining Funds',
    'settled-profit': 'Settled Profit',
    'settlable-profit': 'Settlable Profit',
    'customer-profit-loss': 'Customer Profit Loss',
  },
  'order-detail': {
    'page-title': 'Order detail',
    time: 'Time',
    'participating-account': 'Participating Account',
    'participation-method': 'Participation Method',
    'payment-method': 'Payment Method',
    'change-amount': 'Change Amount',
    'corresponding-main-account': 'Corresponding Main Account',
    'main-account-fund-change': 'Main Account Fund Change',
    'my-wallet': 'My Wallet',
  },
}
